import React, { FC } from 'react'
import { Column } from '../../../models/column'
import useTableTranslation from '@components/UI-Components/HierarchyWiseItemsTable/hooks/use-table-translation'
import { CentricTypography as Typography } from '@core/component/CentricTypography'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core'

export interface CellProps {
  column?: Column
  customClass?: any
}

const useStyles = makeStyles(theme => ({
  enhancedCellWrapper: {
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#eeeeee',
    borderBottom: '1px solid #ccc'
  },
  headerRightBorder: {
    boxShadow: 'rgb(133 146 166 / 20%) 3px 0px 5px -3px',
    borderRight: '2px solid #ccc'
  },
  customBorder: {
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      borderRight: '2px #ccc solid',
      right: 0,
      height: '50%',
      marginTop: 'auto',
      marginBottom: 'auto'
    }
  },
  cell: {
    display: ' -webkit-box',
    overflow: 'hidden',
    textAlign: 'center',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical'
  },
  emptycell: {
    height: '30px',
    width: '100%',
    borderBottom: '1px solid #ccc',
    boxShadow: 'none !important',
    borderRight: 'none !important'
  }
}))

const EmptyHeaderCell: ({ showBorder }) => FC<CellProps> =
  ({ showBorder = false }) =>
  ({ column }) => {
    const { label, key } = column
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { t } = useTableTranslation()
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const classes = useStyles()
    return (
      <>
        <div className={classes.emptycell}></div>
        <div
          className={classNames(classes.enhancedCellWrapper, {
            [classes.customBorder]: !key,
            customBorderOverride: !key,
            [classes.headerRightBorder]: showBorder
          })}
        >
          <span className={classes.cell}>
            <Typography variant={'subtitle2DarkGrey'}>
              {key ? t(`order.listview.colHeader.${key}`, label) : label}
            </Typography>
          </span>
        </div>
      </>
    )
  }

export default EmptyHeaderCell
